import { css, cx } from '@repo/pandacss/styled-system/css';
import type { CSSProperties } from 'react';
import type { ChartLegendItemProps } from '.';
import { DEFAULT_COLORS } from '../constants';

export const LegendItemComponent = ({ item, index }: ChartLegendItemProps) => {
  return (
    <div
      className={cx(
        'star-rating-categories-legend-item',
        css({
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          listStyleType: 'none',
          paddingBlockStart: '3',
          paddingBlockEnd: '3',
          borderBottomStyle: 'solid',
          borderBottomWidth: 'thin',
          borderBottomColor: 'neutral.lighter2',
          _hover: {
            borderBottomColor: 'var(--legend-color)',
          },
          '&.legend-active': {
            borderBottomColor: 'var(--legend-color)',
          },
        }),
      )}
      style={
        {
          '--legend-color': item.color ?? DEFAULT_COLORS[index],
        } as CSSProperties
      }
    >
      <div
        className={css({
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          marginRight: '[50px]',
        })}
      >
        <span
          className={css({
            flexShrink: '[0]',
            display: 'inline-block',
            width: '3.5',
            height: '3.5',
            borderTopLeftRadius: '2',
            borderTopRightRadius: '2',
            borderBottomRightRadius: '2',
            borderBottomLeftRadius: '2',
            backgroundColor: 'var(--legend-color)',
          })}
        />
        <span
          className={css({
            fontSize: 'md',
            fontWeight: 'medium',
            marginLeft: '2',
            color: 'neutral.darker',
          })}
        >
          {item.label}
        </span>
      </div>
      <div
        className={css({
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          columnGap: '2',
          rowGap: '2',
        })}
      >
        <span className={css({ fontSize: 'md', color: 'neutral.dark' })}>{item.value}%</span>
      </div>
    </div>
  );
};
